import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

const ErrorDialog = ({ isOpen, onClose, messages, title = 'Error' }) => {
  const safeMessages = Array.isArray(messages)
    ? messages
    : messages
    ? [messages]
    : [];

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
    >
      <DialogTitle id="error-dialog-title" className="dialog-title">
        <span className="dialog-warning-icon">⚠️</span> {title}
      </DialogTitle>
      <DialogContent id="error-dialog-description" className="dialog-content">
        {safeMessages.length > 0 ? (
          safeMessages.map((message, index) => (
            <div key={index} style={{ marginBottom: '10px' }}>
              {index + 1}. {message}
            </div>
          ))
        ) : (
          <div>Por favor revise los errores.</div>
        )}
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="contained" color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};


export default ErrorDialog;
